import { toast } from 'sonner';

import ToastMessage, { TOAST_STATUS } from './ToastMessage';

export const DEFAULT_DURATION = 6000;
export const DEFAULT_EXTENDED_DURATION = 8000;

export interface ToastProps {
  message: string;
  status: TOAST_STATUS;
  duration?: number;
  onClose?: () => void;
  testId?: string;
}

export interface ToastConfigProps {
  duration?: number;
  onClose?: () => void;
  testId?: string;
}

const useToasts = () => {
  const renderToast = ({
    message,
    status,
    duration,
    onClose,
    testId,
  }: ToastProps) => {
    return toast.custom(
      (id) => (
        <ToastMessage
          testId={testId || `toast-${id}`}
          message={message}
          status={status}
          onClose={() => {
            onClose?.();
            toast.dismiss(id);
          }}
        />
      ),
      {
        duration,
      }
    );
  };

  const createToastMethod = (status: TOAST_STATUS, defaultDuration: number) => {
    return (message: string, config?: ToastConfigProps) => {
      renderToast({
        message,
        status,
        duration: config?.duration || defaultDuration,
        onClose: config?.onClose,
        testId: config?.testId,
      });
    };
  };

  const showErrorToast = createToastMethod(
    TOAST_STATUS.ERROR,
    DEFAULT_EXTENDED_DURATION
  );

  const clearAllToasts = () => {
    toast.dismiss();
  };

  return {
    showErrorToast,
    clearAllToasts,
  };
};

export default useToasts;
